/**
 * Prediction scoring — the core teaching loop.
 *
 * THE GOLDEN RULE: we never score the glucose NUMBER. We score how accurately
 * the player PREDICTED where their glucose would be, because prediction +
 * response is what management actually is. A player whose body betrayed them
 * can still play a perfect game.
 */

export interface PredictionBand {
  id: string;
  label: string;
  /** representative value (mg/dL) used for accuracy scoring */
  value: number;
}

/** Kid-friendly bands; each maps to a representative value for scoring. */
export const PREDICTION_BANDS: PredictionBand[] = [
  { id: 'low', label: 'LOW AMBUSH  (<70)', value: 60 },
  { id: 'steady', label: 'STEADY POWER  (80-140)', value: 110 },
  { id: 'high', label: 'RUNNING HIGH  (150-220)', value: 185 },
  { id: 'sky', label: 'SKY HIGH  (230+)', value: 250 },
];

export interface PredictionScore {
  points: number;
  maxPoints: number;
  rating: string;
  errorMgdl: number;
}

/**
 * Score a prediction against the actual simulated glucose (mg/dL) at the
 * check-in time. Points fall off smoothly; within maxErrorMgdl earns > 0.
 */
export function scorePrediction(
  predictedMgdl: number,
  actualMgdl: number,
  maxErrorMgdl = 120,
): PredictionScore {
  const errorMgdl = Math.abs(predictedMgdl - actualMgdl);
  const accuracy = Math.max(0, 1 - errorMgdl / maxErrorMgdl);
  const points = Math.round(100 * Math.pow(accuracy, 1.4));
  let rating = 'Wild Guess';
  if (points >= 90) rating = 'Curve Whisperer';
  else if (points >= 60) rating = 'Sharp Reader';
  else if (points >= 30) rating = 'Getting Warmer';
  return { points, maxPoints: 100, rating, errorMgdl };
}
